module.exports = __webpack_public_path__ + "img/09d.92d7908b.png";